export const INVITE_PARENT_ROUTE = "invite-parent";
